export const PASSWORD_STRENGTH_ERROR =
  "A senha deve ter pelo menos 8 caracteres, uma letra maiúscula, uma letra minúscula e um caractere especial.";

export const PASSWORD_REQUIREMENTS = [
  {
    id: "minLength",
    label: "8 caracteres ou mais",
    test: (password) => String(password || "").length >= 8,
  },
  {
    id: "uppercase",
    label: "Letra maiúscula",
    test: (password) => /[A-Z]/.test(String(password || "")),
  },
  {
    id: "lowercase",
    label: "Letra minúscula",
    test: (password) => /[a-z]/.test(String(password || "")),
  },
  {
    id: "special",
    label: "Caractere especial",
    test: (password) =>
      /[!@#$%^&*(),.?":{}|<>_\-\\[\]\\/;'`~+=]/.test(String(password || "")),
  },
];

export const getPasswordStrengthChecks = (password) =>
  PASSWORD_REQUIREMENTS.map((requirement) => ({
    ...requirement,
    passed: requirement.test(password),
  }));

export const isStrongPassword = (password) =>
  getPasswordStrengthChecks(password).every((requirement) => requirement.passed);

export const assertStrongPassword = (password) => {
  if (!isStrongPassword(password)) {
    throw new Error(PASSWORD_STRENGTH_ERROR);
  }
};
